import React from 'react';
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    IGameContextViewModel
} from "../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {NetPositionBox} from "./boxes/net-position.box";
import {NetPositionLabelBox} from "./boxes/net-position-label.box";
import {NetPositionValueBox} from "./boxes/net-position-value.box";
import {CyClass} from "../../../../../../common/cy-classes";

interface NetPositionComponentProps {
    gameContext: IGameContextViewModel;
}

export const NetPositionComponent = observer(
    class NetPositionComponent extends OrbitComponent<NetPositionComponentProps> {
        render() {


            return (
                <NetPositionBox>
                    <NetPositionLabelBox>
                        {this.services.translation.translate('GAME_NET_POSITION_LABEL')}
                    </NetPositionLabelBox>
                    <NetPositionValueBox className={CyClass('cy-game-net-position-value')}>
                        {this.services.currency.formatMoney(this.props.gameContext.gameSessionData.netPosition)}
                    </NetPositionValueBox>
                </NetPositionBox>
            )
        }
    }
);